import React, { forwardRef, useImperativeHandle, useRef } from "react"
import { Grid, Paper, Typography } from "@mui/material"
import { DataGrid } from "@mui/x-data-grid"
import { CSVLink } from "react-csv"
import { SALES_TAX_CSV_HEADERS } from "../CSVHeaders"
import useExporter from "../../../utils/useExporter"

const MultiTax = forwardRef((props, ref) => {
  // Hooks
  const exporter = useExporter()
  useImperativeHandle(ref, () => ({
    fetchReport: async (mid, start, end) => {
      setLoading(true)
      const response = await fetch(`/api/reports/salestax?mid=${mid}&start=${start}&end=${end}`)
      const data = await response.json()
      setTaxes(data)
      setLoading(false)
    },
    exportReport: (mid) => {
      exportRef.current.click()
      exporter.export(mid, "Multi-Tax", taxes)
    }
  }))

  // States
  const [loading, setLoading] = React.useState(false)
  const [taxes, setTaxes] = React.useState([])

  // References
  const exportRef = useRef()

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Typography variant="h5" fontWeight="bold" textAlign="center">
          Multi-Tax
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Paper>
          <DataGrid
            loading={loading}
            pageSize={props.pageSize}
            rows={taxes}
            getRowId={row => row.Name}
            columns={[
              { field: "Name", disableColumnMenu: true, minWidth: 100, flex: 1 },
              { field: "Subtotal", disableColumnMenu: true, minWidth: 100, flex: 1 },
              { field: "Card Admin Fee", disableColumnMenu: true, minWidth: 100, flex: 1 },
              { field: "Tax", disableColumnMenu: true, minWidth: 100, flex: 1 },
              { field: "Card Admin Fee Tax", disableColumnMenu: true, minWidth: 100, flex: 1 },
              { field: "Total", disableColumnMenu: true, minWidth: 100, flex: 1 },
              { field: "Quantity", disableColumnMenu: true, minWidth: 100, flex: 1 }
            ]}
          />
        </Paper>
      </Grid>
      <CSVLink
        filename="Multi-Tax"
        headers={SALES_TAX_CSV_HEADERS}
        data={taxes}
      >
        <span ref={exportRef} />
      </CSVLink>
    </Grid>
  )
})

export default MultiTax